import { Modal, ModalContent, ModalActions, Button } from '@hm-group/bads-react';

export interface ModalAction {
  label: string;
  mode?: 'primary' | 'secondary' | 'error' | 'warning' | 'information';
  type?: 'solid' | 'outlined' | 'text';
  onClick: () => void;
}

export interface ConfirmationModalConfig {
  isOpen: boolean;
  header: string;
  message: string;
  actions: ModalAction[];
  onClose: () => void;
}

interface ConfirmationModalProps {
  config: ConfirmationModalConfig;
}

/**
 * Reusable confirmation modal built on top of BADS React Modal.
 * Supports 1-N action buttons with configurable modes (primary, error, warning, etc.).
 * Used for SCA checkbox modals and market removal confirmation.
 */
export function ConfirmationModal({ config }: Readonly<ConfirmationModalProps>) {
  const { isOpen, header, message, actions, onClose } = config;

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={header} minWidth="400px">
      <ModalContent>
        <p style={{ margin: '8px 0', fontSize: '14px' }}>{message}</p>
      </ModalContent>
      <ModalActions align="center">
        {actions.map((action) => (
          <Button
            key={action.label}
            mode={action.mode ?? 'primary'}
            type={action.type ?? 'solid'}
            size="normal"
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        ))}
      </ModalActions>
    </Modal>
  );
}
